import { createSlice } from "@reduxjs/toolkit";

const initSpaces = {
  mySpaces: [],
  searchSpaces: [],
  venueSpaces: [],
  // Filters published by Milo. Search.tsx subscribes and applies them, so the
  // marketplace stays the single search authority instead of the agent
  // maintaining a second, competing result list.
  agentFilters: null as any,
};

const reducers = {
  /**
   * Publish a filter set from Milo. `appliedAt` changes on every call so that
   * asking for the same thing twice still re-triggers the marketplace search.
   */
  setAgentFilters: (state: any, action: any) => {
    state.agentFilters = {
      filters: action.payload.filters,
      appliedAt: Date.now(),
    };
  },
  getSearchSpaces: (state: any, action: any) => {
    const newItems = action.payload.items;
    const updateList = action.payload.updateList;

    // The unconditional assignment that used to follow the `if` made the
    // append branch dead code, so page 2 replaced page 1 instead of extending
    // it. Mirrors getVenueSpaces, including id-based de-duplication.
    if (updateList) {
      state.searchSpaces = newItems;
    } else {
      const existingIds = new Set(
        state.searchSpaces.map((item: { id: string }) => item.id)
      );
      const filteredItems = newItems.filter(
        (item: { id: string }) => !existingIds.has(item.id)
      );

      state.searchSpaces.push(...filteredItems);
    }
  },
  getMySpaces: (state: any, action: any) => {
    const items = action.payload.items;

    state.mySpaces = items;
  },
  getVenueSpaces: (state: any, action: any) => {
    const newItems = action.payload.items;
    const updateList = action.payload.updateList;

    if (updateList) {
      state.venueSpaces = newItems;
    } else {
      const existingIds = new Set(
        state.venueSpaces.map((item: { id: string }) => item.id)
      );
      const filteredItems = newItems.filter(
        (item: { id: string }) => !existingIds.has(item.id)
      );

      state.venueSpaces.push(...filteredItems);
    }
  },
  createVenueSpace: (state: any, action: any) => {
    const newSpot = action.payload.item;

    state.venueSpaces.unshift(newSpot);
  },
  updateVenueSpace: (state: any, action: any) => {
    const tempItems = state.venueSpaces;
    const newItem = action.payload.item;

    const index = tempItems.findIndex(
      (item: { id: string }) => item.id === newItem.id
    );

    state.venueSpaces[index] = newItem;
  },
  deleteVenueSpace: (state: any, action: any) => {
    const tempItems = [...state.venueSpaces];
    const itemID = action.payload.id;

    const updatedLlist = tempItems.filter((item) => item.id !== itemID);

    state.venueSpaces = updatedLlist;
  },
};

const SpaceReducers = createSlice({
  name: "spacesReducers",
  initialState: initSpaces,
  reducers,
});

export const {
  setAgentFilters,
  getVenueSpaces,
  createVenueSpace,
  updateVenueSpace,
  deleteVenueSpace,
  getSearchSpaces,
  getMySpaces,
} = SpaceReducers.actions;

export default SpaceReducers.reducer;
